import React, { useState } from "react";
// import FormCapaianIK from "../FormCapaianIK";
import { FORM_TYPE } from "../../../../Constant/FormType";
import FormCapaianIK from "../components/FormCapaianIK";

const BuatCapaianIK = () => {

  const [formCapaianIK, setFormCapaianIK] = useState({
    unit_kerja: "",
    perspektif: "",
    kode_ss: "",
    nama_ss: "",
    kode_ik: "",
    nama_ik: "",
    formula: "",
    polarisasi: "",
    tipe_konsolidasi: "",
    satuan_capaian: "",
    bobot_ik: 0,
    target_tw_1: 0,
    target_tw_2: 0,
    target_tw_3: 0,
    target_tw_4: 0,
    capaian_tw_1: 0,
    capaian_tw_2: 0,
    capaian_tw_3: 0,
    capaian_tw_4: 0,
    total_target_tw_1: 0,
    total_target_tw_2: 0,
    total_target_tw_3: 0,
    total_target_tw_4: 0,
    total_capaian_tw_1: 0,
    total_capaian_tw_2: 0,
    total_capaian_tw_3: 0,
    total_capaian_tw_4: 0,
    persentase_capaian_tw_1: 0,
    persentase_capaian_tw_2: 0,
    persentase_capaian_tw_3: 0,
    persentase_capaian_tw_4: 0,
    persentase_capaian_normalisasi_tw_1: 0,
    persentase_capaian_normalisasi_tw_2: 0,
    persentase_capaian_normalisasi_tw_3: 0,
    persentase_capaian_normalisasi_tw_4: 0,
    nilai_indikator_tw_1: 0,
    nilai_indikator_tw_2: 0,
    nilai_indikator_tw_3: 0,
    nilai_indikator_tw_4: 0,
    nilai_indikator_normalisasi_tw_1: 0,
    nilai_indikator_normalisasi_tw_2: 0,
    nilai_indikator_normalisasi_tw_3: 0,
    nilai_indikator_normalisasi_tw_4: 0,
    status_tw_1: "",
    status_tw_2: "",
    status_tw_3: "",
    status_tw_4: "",
    last_uploaded_document_tw_1: "",
    last_uploaded_document_tw_2: "",
    last_uploaded_document_tw_3: "",
    last_uploaded_document_tw_4: "",
    keterangan_tw_1: "",
    keterangan_tw_2: "",
    keterangan_tw_3: "",
    keterangan_tw_4: "",
    uploaded_document: "",
    anggaran: 0,
    komitmen: 0,
    aktual: 0,
    sisa_anggaran: 0,
  })

  return (
    <FormCapaianIK
      formCapaianIK={formCapaianIK}
      setFormCapaianIK={setFormCapaianIK}
      formType={FORM_TYPE.Create}
    />
  )
}

export default BuatCapaianIK;